var _excluded = ["openingMessage", "errorTitle", "titularElementTag", "errorMessage", "linksProps", "data-testid"];
var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/FiveHundredError/FiveHundredError.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box } from '@wds/box';
import { t, defineMessages } from '@sm/intl';
import { ClientError } from '../ClientError';
import Links from '../ClientError/Links';
import { withWebAssetsTheme } from '../../theme';
var DEFAULT_COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FiveHundredError.SorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message'
  },
  SOMETHING_WRONG: {
    id: 'FiveHundredError.SomethingWentWrong',
    defaultMessage: 'Something went wrong.',
    description: '[Type: Label][Vis.: med] - something went wrong subtitle'
  },
  FIVE_HUNDRED_MESSAGE: {
    id: 'FiveHundredError.Message',
    defaultMessage: "Sorry if you lost your place - we're working hard to get things up and running again. Thanks for your patience!",
    description: '[Type: Label][Vis.: med] - Five Hundred Error Message'
  }
});
var FiveHundredError = function FiveHundredError(_ref) {
  var _ref$openingMessage = _ref.openingMessage,
    openingMessage = _ref$openingMessage === void 0 ? t(DEFAULT_COPY.SORRY_MESSAGE) : _ref$openingMessage,
    _ref$errorTitle = _ref.errorTitle,
    errorTitle = _ref$errorTitle === void 0 ? t(DEFAULT_COPY.SOMETHING_WRONG) : _ref$errorTitle,
    _ref$titularElementTa = _ref.titularElementTag,
    titularElementTag = _ref$titularElementTa === void 0 ? 'p' : _ref$titularElementTa,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? t(DEFAULT_COPY.FIVE_HUNDRED_MESSAGE) : _ref$errorMessage,
    linksProps = _ref.linksProps,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'FiveHundredError' : _ref$dataTestid,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ClientError, Object.assign({
    openingMessage: openingMessage,
    errorTitle: errorTitle,
    titularElementTag: titularElementTag,
    "data-testid": dataTestId
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, React.Children.map(errorMessage, function (message) {
    return /*#__PURE__*/React.createElement("p", {
      "data-testid": "".concat(dataTestId, "_ErrorMessage"),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 18
      }
    }, message);
  })), /*#__PURE__*/React.createElement(Links, Object.assign({}, linksProps, {
    mt: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  })));
};
export default withWebAssetsTheme(FiveHundredError);
//# sourceMappingURL=FiveHundredError.js.map